<template>
  <hr class="my-2 dark:border-gray-700">
</template>

<script setup></script>
